import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { sp } from "@pnp/sp";
import "@pnp/sp/webs";
import "@pnp/sp/lists";
import "@pnp/sp/items";
import { IItemAddResult, IItemUpdateResult } from "@pnp/sp/items";

import { Constantes } from "../utils/Constantes";
import { ELog } from "../models/entidades/ELog";
import { ListItem } from "../models/base/ListItem";
import { from, Observable, BehaviorSubject, Subject } from "rxjs";
import { Deferred } from "ts-deferred";
import { RestFiltros } from '../utils/RestFiltros';

const cacheBuster$ = new Subject<void>();

@Injectable({
  providedIn: "root"
})
export class MasterService {

  constructor() {   
  } 
}
